import { signal, effect } from '@preact/signals-react';
import { alertaMensagem } from './alerta';

export const onlineSignal = signal(typeof navigator !== 'undefined' ? navigator.onLine : true);

function handleOnline() {
    onlineSignal.value = true;
}

function handleOffline() {
    onlineSignal.value = false;
}

let conectividadeInicializada = false;

export function initConectividade() {
    if (typeof window === 'undefined') return;
    if (conectividadeInicializada) return;
    conectividadeInicializada = true;

    // remove-then-add: idempotente mesmo em HMR / re-execução
    window.removeEventListener('online', handleOnline);
    window.removeEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Reage a mudanças de conectividade, mas ignora o estado inicial
    let primeiroDisparo = true;
    effect(() => {
        const online = onlineSignal.value;

        if (primeiroDisparo) {
            primeiroDisparo = false;
            return;
        }

        alertaMensagem.value = online
            ? {
                  open: true,
                  title: 'Conexão restabelecida',
                  message: 'Você está online novamente.',
                  type: 'success',
              }
            : {
                  open: true,
                  title: 'Sem conexão',
                  message: 'Você está offline. Algumas funcionalidades podem não estar disponíveis.',
                  type: 'alert',
              };
    });
}
